export const ModalSmWidth = '340px';
export const ModalMdWidth = '540px';
export const ModalLgWidth = '740px';
export const TimeoutOnSearch = 500;